/* ==========================================================================
   Flipbook init helper — utilise la librairie "page-flip" (St.PageFlip).
   Version identique à celle qui fonctionnait bien le matin même (rendu
   par canvas), avec le correctif de netteté écran Retina.
   ========================================================================== */

function sharpenCanvasForRetina(bookEl) {
  var dpr = window.devicePixelRatio || 1;
  if (dpr <= 1) return;

  var applying = false;
  var observer = null;

  function apply() {
    var canvas = bookEl.querySelector('canvas.stf__canvas');
    if (!canvas || !canvas.width || !canvas.height) return;

    var alreadyScaled = canvas.getAttribute('data-fb-dpr') === String(dpr);
    if (alreadyScaled) return;

    applying = true;
    if (observer) observer.disconnect();

    var cssW = canvas.width;
    var cssH = canvas.height;
    canvas.width = Math.round(cssW * dpr);
    canvas.height = Math.round(cssH * dpr);
    canvas.setAttribute('data-fb-dpr', String(dpr));

    var ctx = canvas.getContext('2d');
    ctx.scale(dpr, dpr);

    applying = false;
    if (observer) observer.observe(canvas, { attributes: true, attributeFilter: ['width', 'height'] });
  }

  function watch() {
    var canvas = bookEl.querySelector('canvas.stf__canvas');
    if (!canvas) {
      setTimeout(watch, 50);
      return;
    }
    observer = new MutationObserver(function () {
      if (applying) return;
      canvas.removeAttribute('data-fb-dpr');
      apply();
    });
    observer.observe(canvas, { attributes: true, attributeFilter: ['width', 'height'] });
    apply();
  }

  watch();
}

function escapeXmlForWatermark(str) {
  return String(str).replace(/[<>&'"]/g, function (c) {
    if (c === '<') return '&lt;';
    if (c === '>') return '&gt;';
    if (c === '&') return '&amp;';
    if (c === "'") return '&apos;';
    return '&quot;';
  });
}

function buildWatermarkDataUri(text) {
  if (!text) return null;
  var safe = escapeXmlForWatermark(text);
  var svg = '<svg xmlns="http://www.w3.org/2000/svg" width="300" height="220">' +
    '<text x="150" y="115" font-size="15" font-family="Arial, sans-serif" ' +
    'fill="rgba(74,68,56,0.16)" text-anchor="middle" transform="rotate(-30 150 115)">' +
    safe + '</text></svg>';
  return 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svg);
}

function applyWatermark(el, text) {
  if (!el) return;
  var uri = buildWatermarkDataUri(text);
  if (!uri) return;
  el.style.backgroundImage = 'url("' + uri + '")';
  el.style.backgroundRepeat = 'repeat';
}

function initArabicFlipbook(rootId, pages, options) {
  options = options || {};

  var root = document.getElementById(rootId);
  if (!root || !pages || !pages.length) return;

  var stage = root.querySelector('.flipbook-stage');
  var bookEl = root.querySelector('.flipbook');
  var loadingEl = root.querySelector('.flipbook-loading');
  var prevBtn = root.querySelector('.fb-prev');
  var nextBtn = root.querySelector('.fb-next');
  var currentEl = root.querySelector('.fb-current');
  var totalEl = root.querySelector('.fb-total');
  var gotoInput = root.querySelector('.fb-goto-input');
  var gotoBtn = root.querySelector('.fb-goto-btn');
  var zoomBtn = root.querySelector('.fb-zoom-float');
  var watermarkEl = root.querySelector('.fb-watermark');
  var watermarkText = watermarkEl ? watermarkEl.getAttribute('data-watermark') : null;
  var paywallEl = root.parentNode ? root.parentNode.querySelector('.book-paywall') : null;
  var paywallCloseBtn = paywallEl ? paywallEl.querySelector('.book-paywall-close') : null;
  var lockedFrom = options.lockedFrom || null; // index (1-based count) à partir duquel c'est verrouillé

  if (totalEl) totalEl.textContent = pages.length;

  function boot() {
    if (typeof St === 'undefined' || !St.PageFlip) {
      setTimeout(boot, 50);
      return;
    }

    var baseW = options.width || 1100;
    var baseH = options.height || 1556;

    var pageFlip = new St.PageFlip(bookEl, {
      width: baseW,
      height: baseH,
      size: 'stretch',
      minWidth: 280,
      maxWidth: options.maxWidth || 1300,
      minHeight: 396,
      maxHeight: options.maxHeight || 1838,
      showCover: true,
      maxShadowOpacity: 0.5,
      mobileScrollSupport: false,
      useMouseEvents: true,
      flippingTime: 700
    });

    pageFlip.loadFromImages(pages);
    sharpenCanvasForRetina(bookEl);
    applyWatermark(watermarkEl, watermarkText);

    if (loadingEl) loadingEl.style.display = 'none';
    if (stage) stage.style.display = 'flex';

    function updateUI() {
      var idx = pageFlip.getCurrentPageIndex();
      if (currentEl) currentEl.textContent = idx + 1;
      if (prevBtn) prevBtn.disabled = idx <= 0;
      if (nextBtn) nextBtn.disabled = idx >= pages.length - 1;

      if (paywallEl && lockedFrom) {
        if (idx + 1 > lockedFrom) {
          paywallEl.classList.add('is-visible');
        } else {
          paywallEl.classList.remove('is-visible');
        }
      }
    }

    pageFlip.on('flip', updateUI);
    pageFlip.on('init', updateUI);
    updateUI();

    if (paywallCloseBtn) {
      paywallCloseBtn.addEventListener('click', function () {
        paywallEl.classList.remove('is-visible');
        if (lockedFrom) pageFlip.flip(lockedFrom - 1);
      });
    }

    if (prevBtn) prevBtn.addEventListener('click', function () {
      pageFlip.flipPrev();
    });
    if (nextBtn) nextBtn.addEventListener('click', function () {
      pageFlip.flipNext();
    });

    if (gotoBtn && gotoInput) {
      gotoBtn.addEventListener('click', function () {
        var n = parseInt(gotoInput.value, 10);
        if (!isNaN(n) && n >= 1 && n <= pages.length) {
          pageFlip.flip(n - 1);
        }
      });
      gotoInput.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') gotoBtn.click();
      });
    }

    root.setAttribute('tabindex', '0');
    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') pageFlip.flipNext();
      if (e.key === 'ArrowRight') pageFlip.flipPrev();
    });

    setupZoomLightbox(pageFlip, pages, zoomBtn, watermarkText);
  }

  boot();
}

function setupZoomLightbox(pageFlip, pages, zoomBtn, watermarkText) {
  if (!zoomBtn) return;

  var overlay, inner, imgEl, closeBtn;
  var scale = 1, tx = 0, ty = 0;
  var baseW = 0, baseH = 0;
  var pointers = {};
  var pinchStartDist = 0, pinchStartScale = 1;
  var panStart = null, startTx = 0, startTy = 0;
  var lastTapTime = 0, lastTapPos = null;

  function dist(p1, p2) {
    var dx = p1.x - p2.x, dy = p1.y - p2.y;
    return Math.sqrt(dx * dx + dy * dy);
  }

  function applyTransform() {
    // Les images des pages sont pré-inversées (comme dans le feuilleteur, qui les
    // affiche via un miroir CSS). Ici on applique le même miroir, en compensant le
    // sens du glissement (négation de tx) pour que le geste reste naturel au doigt.
    imgEl.style.transform = 'scaleX(-1) translate(' + (-tx) + 'px,' + ty + 'px) scale(' + scale + ')';
  }

  function clampPan() {
    if (!baseW || !baseH || !inner) return;
    var containerW = inner.clientWidth;
    var containerH = inner.clientHeight;
    var scaledW = baseW * scale;
    var scaledH = baseH * scale;
    var maxX = Math.max(0, (scaledW - containerW) / 2);
    var maxY = Math.max(0, (scaledH - containerH) / 2);
    if (tx > maxX) tx = maxX;
    if (tx < -maxX) tx = -maxX;
    if (ty > maxY) ty = maxY;
    if (ty < -maxY) ty = -maxY;
  }

  function measureBase() {
    // Taille réellement affichée de l'image (contrainte par max-width/max-height),
    // mesurée à scale=1, pour calculer des limites de défilement correctes.
    var prevTransform = imgEl.style.transform;
    imgEl.style.transform = 'none';
    var rect = imgEl.getBoundingClientRect();
    baseW = rect.width;
    baseH = rect.height;
    imgEl.style.transform = prevTransform;
  }

  function resetTransform(startScale) {
    scale = startScale || 1;
    tx = 0;
    ty = 0;
    applyTransform();
  }

  function build() {
    overlay = document.createElement('div');
    overlay.className = 'book-zoom-overlay';

    inner = document.createElement('div');
    inner.className = 'book-zoom-inner';

    imgEl = document.createElement('img');
    imgEl.className = 'book-zoom-img';
    imgEl.draggable = false;
    inner.appendChild(imgEl);

    closeBtn = document.createElement('button');
    closeBtn.type = 'button';
    closeBtn.className = 'book-zoom-close';
    closeBtn.setAttribute('aria-label', 'Fermer le zoom');
    closeBtn.textContent = '✕';

    var hint = document.createElement('div');
    hint.className = 'book-zoom-hint';
    hint.textContent = 'Double-cliquez (ou double-touchez) pour zoomer — molette ou flèches pour défiler';

    overlay.appendChild(inner);

    if (watermarkText) {
      var wm = document.createElement('div');
      wm.className = 'book-zoom-watermark';
      applyWatermark(wm, watermarkText);
      overlay.appendChild(wm);
    }

    var nav = document.createElement('div');
    nav.className = 'book-zoom-nav';
    var dirs = [
      { cls: 'up', dx: 0, dy: 1, label: 'Monter', icon: 'M12 5l-7 7h4v7h6v-7h4z' },
      { cls: 'down', dx: 0, dy: -1, label: 'Descendre', icon: 'M12 19l7-7h-4V5H9v7H5z' },
      { cls: 'left', dx: 1, dy: 0, label: 'Aller à gauche', icon: 'M5 12l7-7v4h7v6h-7v4z' },
      { cls: 'right', dx: -1, dy: 0, label: 'Aller à droite', icon: 'M19 12l-7-7v4H5v6h7v4z' }
    ];
    dirs.forEach(function (d) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'book-zoom-nav-btn book-zoom-nav-' + d.cls;
      btn.setAttribute('aria-label', d.label);
      btn.innerHTML = '<svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor"><path d="' + d.icon + '"></path></svg>';
      btn.addEventListener('click', function () {
        var step = 80;
        tx += d.dx * step;
        ty += d.dy * step;
        clampPan();
        applyTransform();
      });
      nav.appendChild(btn);
    });

    overlay.appendChild(closeBtn);
    overlay.appendChild(nav);
    overlay.appendChild(hint);
    document.body.appendChild(overlay);

    closeBtn.addEventListener('click', close);
    inner.addEventListener('pointerdown', onPointerDown);
    inner.addEventListener('pointermove', onPointerMove);
    inner.addEventListener('pointerup', onPointerUp);
    inner.addEventListener('pointercancel', onPointerUp);
    inner.addEventListener('pointerleave', onPointerUp);
    inner.addEventListener('wheel', onWheel, { passive: false });
  }

  function open() {
    if (!overlay) build();
    var idx = pageFlip.getCurrentPageIndex();
    imgEl.src = pages[idx];
    resetTransform(1.8);
    overlay.classList.add('is-visible');
    document.body.style.overflow = 'hidden';

    if (imgEl.complete) {
      requestAnimationFrame(measureBase);
    } else {
      imgEl.onload = function () { measureBase(); };
    }
  }

  function close() {
    if (overlay) overlay.classList.remove('is-visible');
    document.body.style.overflow = '';
    pointers = {};
    pinchStartDist = 0;
    panStart = null;
  }

  function onPointerDown(e) {
    pointers[e.pointerId] = { x: e.clientX, y: e.clientY };
    var ids = Object.keys(pointers);

    if (ids.length === 2) {
      var p1 = pointers[ids[0]], p2 = pointers[ids[1]];
      pinchStartDist = dist(p1, p2);
      pinchStartScale = scale;
      panStart = null;
    } else if (ids.length === 1) {
      panStart = { x: e.clientX, y: e.clientY };
      startTx = tx;
      startTy = ty;

      var now = Date.now();
      var pos = { x: e.clientX, y: e.clientY };
      if (lastTapPos && now - lastTapTime < 300 && dist(lastTapPos, pos) < 30) {
        scale = scale > 1 ? 1 : 2.5;
        if (scale === 1) { tx = 0; ty = 0; }
        clampPan();
        applyTransform();
        lastTapTime = 0;
        lastTapPos = null;
      } else {
        lastTapTime = now;
        lastTapPos = pos;
      }
    }
  }

  function onPointerMove(e) {
    if (!pointers[e.pointerId]) return;
    pointers[e.pointerId] = { x: e.clientX, y: e.clientY };
    var ids = Object.keys(pointers);

    if (ids.length === 2 && pinchStartDist > 0) {
      var p1 = pointers[ids[0]], p2 = pointers[ids[1]];
      var d = dist(p1, p2);
      scale = Math.min(4, Math.max(1, pinchStartScale * (d / pinchStartDist)));
      if (scale === 1) { tx = 0; ty = 0; }
      clampPan();
      applyTransform();
    } else if (ids.length === 1 && panStart && scale > 1) {
      tx = startTx + (e.clientX - panStart.x);
      ty = startTy + (e.clientY - panStart.y);
      clampPan();
      applyTransform();
    }
  }

  function onPointerUp(e) {
    delete pointers[e.pointerId];
    if (Object.keys(pointers).length < 2) pinchStartDist = 0;
    if (Object.keys(pointers).length === 0) panStart = null;
  }

  function onWheel(e) {
    e.preventDefault();

    // Pincement trackpad (ou Ctrl+molette) = zoom. Molette / glissement à deux
    // doigts classique = toujours un défilement dans l'image, quel que soit le
    // niveau de zoom actuel (avant, ça restait bloqué à zoom 1 si on
    // commençait à défiler "vers le bas").
    if (e.ctrlKey) {
      scale = Math.min(4, Math.max(1, scale + (e.deltaY < 0 ? 0.2 : -0.2)));
      if (scale === 1) { tx = 0; ty = 0; }
      clampPan();
      applyTransform();
      return;
    }

    tx -= e.deltaX;
    ty -= e.deltaY;
    clampPan();
    applyTransform();
  }

  zoomBtn.addEventListener('click', open);
}

window.initArabicFlipbook = initArabicFlipbook;
